import { JwtHelperService } from '@auth0/angular-jwt';

export class User {
  constructor(
    public id: string,
    public email: string,
    private _accessToken: string,
    private _refreshToken: string
  ) {}

  private jwtHelper: JwtHelperService = new JwtHelperService();

  public get accessToken(): string {
    return this._accessToken;
  }

  public get refreshToken(): string | null {
    return this.jwtHelper.isTokenExpired(this._refreshToken) ? null : this._refreshToken;
  }
}
